import React, { useState, useEffect } from "react";
import { Filter, Clock, Search } from "lucide-react";
import { Button } from "../../../shadcn/components/ui/Button";
import { Input } from "../../../shadcn/components/ui/Input";
import { Badge } from "../../../shadcn/components/ui/Badge";
import industryrelations1 from "../../../assets/serviceProvider dashboard/industry relations/industryrelations1.webp";
import { IndustryPopup } from "./IndustryPopup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import GroupChat from "./Publicmessage";


export function IndustryRelations() {
  const [data, setData] = useState({ groups: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [displayedUsers, setDisplayedUsers] = useState(users.slice(0, 5));
  const navigate=useNavigate()
  const role=localStorage.getItem("userRole")

  useEffect(() => {
    if (searchTerm) {
      setDisplayedUsers(
        users.filter(user =>
          user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else {
      setDisplayedUsers(users);
    }
  }, [searchTerm, users]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.post(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/message/usergroup",
          { token }
        );
        const jsonData = await response.data;
        console.log(jsonData);
        setData(jsonData);
      } catch (error) {
        console.log(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleUserClick = async (user) => {
    try {
      const token = localStorage.getItem("authToken");
      const currentemail = localStorage.getItem("email");
  
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/create",
        {
          members: [user.email, currentemail], // Pass the user's email as a member
          groupName: ` ${user.name}`, // Optional: Dynamic group name
          token, // Include the auth token
        }
      );
  
      console.log("Group Created:", response.data);
  
      navigateToMessages(); // Navigate based on role
  
      // Fetch updated groups after creation
      const updatedGroupsResponse = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/message/usergroup",
        { token }
      );
      setData(updatedGroupsResponse.data);
    } catch (error) {
      if (error.response && error.response.status === 409) {
        console.log("Group already exists, navigating to messages.");
        navigateToMessages();
      } else {
        console.error("Error creating group:", error);
      }
    }
  };
  
  // Function to navigate based on role
  const navigateToMessages = () => {
    if (role === "Service Provider") {
      navigate("/servicedashboard/messages");
    } else if (role === "Managed Care Organizations") {
      navigate("/Managed Care Organization's/messages");
    } else if (role === "Individual") {
      navigate("/Dashboard/messages");
    } else if (role === "Property Owner") {
      navigate("/propertyownerdashboard/messages");
    } else if (role === "Non Profits") {
      navigate("/501 C3 Corporations/messages");
    } else if (role === "Real Estate Professionals") {
      navigate("/Hospital/HospitalSystems/messages");
    } else if (role === "SuperAdmin") {
      navigate("/superadmin/messages");
    }
  };
  
  

  const messageBoardsGroups = data.groups.filter(
    (group) => group.members.length === 2
  );
  const chatRoomsGroups = data.groups.filter(
    (group) => group.members.length > 2
  );
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/get-userdata",
         
        );
        setUsers(response.data.usersData);
        const user=response.data.usersData
        console.log(user)
      } catch (error) {
        console.log(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative lg:h-[400px] h-[300px] mb-6">
        <div
          className="absolute inset-0 bg-cover bg-center rounded-xl"
          style={{
            backgroundImage: `url(${industryrelations1})`,
          }}
        >
          <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative h-full flex flex-col items-center justify-center lg:px-4 px-3">
          <h1 className="text-2xl md:text-4xl font-bold md:px-3 flex items-center justify-center text-white mb-6 w-full">
            Industry Relations
          </h1>
          <div className="w-full max-w-3xl flex gap-2 lg:flex-row flex-col">
            <div className="relative flex-1">
              <Input
                placeholder="Search for discussions, professionals, or chat rooms"
                className="w-full pl-10 bg-white"
              />
              <Search className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
            </div>
            <Button
              variant="secondary"
              className="gap-2 bg-blue-500 text-white hover:bg-blue-600"
            >
              <Filter className="h-4 w-4" />
              Filter By Topic                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
            </Button>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Message Boards */}
          <div>
      <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        Users
      </h2>
      <input
        type="text"
        placeholder="Search ..."
        value={searchTerm}
        onChange={handleSearch}
        className="mb-4 p-2 ml-4 w-[50vw] sm:w-[30vw] border border-gray-300 rounded"
      />
    <div className="container mx-auto px-4 no-scrollbar">
  <div className="space-y-4 overflow-y-auto no-scrollbar" style={{ maxHeight: '300px' }}>
    {Array.isArray(displayedUsers) &&
      displayedUsers.map((user) => (
        <div
          key={user._id}
          onClick={() => handleUserClick(user)}
          className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md cursor-pointer transition-shadow"
        >
          <h3 className="font-medium mb-2">{user.name}</h3>
          <p className="text-sm text-gray-600">Email: {user.email}</p>
          <p className="text-sm text-gray-600">Phone: {user.phonenumber}</p>
          <p className="text-sm text-gray-600">Role: {user.role}</p>
        </div>
      ))}
  </div>
</div>

    </div>

          {/* Chat Rooms */}
          <div>
            <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
              Chat Rooms
            </h2>
            <div className="space-y-4">
              {chatRoomsGroups.map((group) => (
                <div key={group._id} className="bg-white p-4 rounded-lg shadow-sm">
                  <h3 className="font-medium mb-2">{group.groupName}</h3>
                  <p className="text-sm text-gray-600 mb-3">
                    Created at: {new Date(group.createdAt).toLocaleString()}
                  </p>
                  <p className="text-sm text-gray-600 mb-3">
                    Total Members: {group.totalMembers}
                  </p>
                  <div className="text-sm text-gray-500 mb-1">Members:</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {group.members.map((member) => (
                      <div key={member._id} className="text-sm text-gray-700">
                        {member.email}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="px-6">
              <IndustryPopup />
            </div>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="w-full flex items-start justify-start flex-col p-5 mt-5">
        <div className="text-xl font-semibold mb-4 flex items-center gap-2">
          <Clock />
          <p className="">Recent Activity</p>
        </div>

       
          {/* More boxes */}
          <GroupChat/>
        </div>
      
    </div>
  );
}
